import { Box, Skeleton, styled } from '@mui/material';

const SkeletonContainer = styled(Box)(({ theme }) => ({
    padding: `0 ${theme.spacing(4)}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
}));

export const SetsConfigDetailsSkeleton = (): JSX.Element => (
    <SkeletonContainer>
        <Skeleton height={48} variant="rounded" width={320} />
        <Skeleton height={48} variant="rounded" width="100%" />
        <Skeleton height={180} variant="rounded" width="100%" />
        <Skeleton height={180} variant="rounded" width="100%" />
    </SkeletonContainer>
);
